import React from 'react';
import PropTypes from 'prop-types';
import { backgroundImage } from '../../../utils/background-image';
import styles from '../../../components/PromoIconography/BrandIcon/BrandIcon.scss';
import { useConfig } from '../../../config/ContentComponentLibraryProvider';
const BrandIcon = ({ display, image, position, adjust }) => {
    const config = useConfig();
    if (!display || !image || !image.src)
        return null;
    const iconPosition = position ? styles[position] || '' : '';
    const pull = adjust ? ` ${styles.notATradingCell}` : '';
    return (React.createElement("div", { className: `${iconPosition}${pull}` },
        React.createElement("div", { className: styles.brandImage, style: backgroundImage(image, config.cfDomain), "data-testid": "brand-icon" })));
};
BrandIcon.displayName = 'BrandIcon';
BrandIcon.defaultProps = {
    adjust: false,
    display: false,
    image: undefined,
    position: undefined,
};
BrandIcon.propTypes = {
    adjust: PropTypes.bool,
    display: PropTypes.bool,
    image: PropTypes.object,
    position: PropTypes.string,
};
export default BrandIcon;
//# sourceMappingURL=index.js.map